<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar :class="{ 'cms-toolbar--alert': isMailAll }" dark>
        <v-toolbar-title>{{ mailTypeText }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch v-model="isMailAll" label="전체 / 타겟" inset hide-details></v-switch>
        <v-btn small outlined class="ml-4" @click="openMailConfig">
          <v-icon left small>mdi-cog</v-icon>우편설정
        </v-btn>
      </v-toolbar>

      <!-- ===== 우편설정: AI친구(이름+썸네일) 관리 다이얼로그 (포인트 채굴기 우편과 동일) ===== -->
      <v-dialog v-model="mailConfigDialog" max-width="640" persistent scrollable>
        <v-card>
          <v-toolbar dark color="#37474F" flat>
            <v-toolbar-title>우편설정 · AI친구 목록</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="mailConfigDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text style="max-height:70vh;">
            <!-- 등록된 친구 목록 -->
            <div class="text-subtitle-2 font-weight-bold mt-3 mb-1">등록된 친구</div>
            <v-list two-line dense>
              <v-list-item v-if="mailFriends.length === 0">
                <v-list-item-content>
                  <v-list-item-subtitle>아직 등록된 친구가 없습니다. 아래에서 추가하세요.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-for="(f, i) in mailFriends" :key="f.id">
                <v-list-item-avatar tile size="48">
                  <img :src="thumbUrl(f.thumb)" alt="thumb"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ f.name }}</v-list-item-title>
                  <v-list-item-subtitle class="grey--text">#{{ i + 1 }} · {{ f.id }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider class="my-4"/>

            <!-- 친구 추가 폼 (추가만 가능) -->
            <div class="text-subtitle-2 font-weight-bold mb-2">친구 추가</div>
            <v-text-field v-model="newFriendName" label="친구 이름" outlined dense hide-details="auto" class="mb-3"></v-text-field>
            <v-file-input
              label="썸네일 이미지 (256x256 자동 재단)"
              accept="image/*"
              outlined
              dense
              prepend-icon="mdi-camera"
              show-size
              hide-details="auto"
              @change="onFriendThumbChange"
            ></v-file-input>
            <div v-if="newFriendPreview" class="mt-3 d-flex align-center">
              <v-avatar tile size="96" class="mr-3" style="border:1px solid #ccc;">
                <img :src="newFriendPreview" alt="preview"/>
              </v-avatar>
              <span class="grey--text text-caption">미리보기 (256x256 재단 결과)</span>
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="mailConfigDialog = false">닫기</v-btn>
            <v-btn color="lime accent-3" :loading="friendSaving" :disabled="friendSaving" @click="AddMailFriend">친구 추가하기</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-list>
        <!-- 타겟 유저 -->
        <v-list-item v-if="!isMailAll">
          <span class="d-inline-block" style="width:160px"><v-card-title class="font-weight-bold">타겟 유저</v-card-title></span>
          <v-text-field label="유저 아이디 입력" v-model="targetUser"></v-text-field>
        </v-list-item>
        <v-divider/>

        <!-- 메일 제목 -->
        <v-list-item>
          <span style="width:160px"><v-card-title class="font-weight-bold">메일 제목</v-card-title></span>
          <v-text-field label="메일 발송 제목" v-model="mailTitle"></v-text-field>
        </v-list-item>

        <!-- 메시지 -->
        <v-divider/>
        <v-list-item class="mt-4">
          <span style="width:160px"><v-card-title class="font-weight-bold">메시지</v-card-title></span>
          <v-textarea filled v-model="mailMessage" label="메시지를 입력하세요."></v-textarea>
        </v-list-item>

        <!-- 날짜 선택 -->
        <v-divider/>
        <v-list-item>
          <span style="width:140px"><v-card-title class="font-weight-bold">날짜 선택</v-card-title></span>
          <span style="width:120px" class="mr-3">
            <v-menu v-model="date_picker_1" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="date_begin" clearable label="시작날짜" readonly v-bind="attrs" v-on="on" @click:clear="date_begin = null" style="max-width:120px;"></v-text-field>
              </template>
              <v-date-picker v-model="date_begin" @change="date_picker_1 = false"></v-date-picker>
            </v-menu>
          </span>
          <span style="width:120px" class="mr-3">
            <v-menu ref="menut1" v-model="menut1" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time1" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="time1" label="시작 시간" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menut1" v-model="time1" full-width :use-seconds="true" @click:second="$refs.menut1.save(time1)"></v-time-picker>
            </v-menu>
          </span>
          <span class="mr-3">~~~~~~</span>
          <span style="width:120px" class="mr-3">
            <v-menu v-model="date_picker_2" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="date_end" clearable label="종료날짜" readonly v-bind="attrs" v-on="on" @click:clear="date_end = null"></v-text-field>
              </template>
              <v-date-picker v-model="date_end" @change="date_picker_2 = false"></v-date-picker>
            </v-menu>
          </span>
          <span style="width:120px">
            <v-menu ref="menut2" v-model="menut2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time2" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="time2" label="종료 시간" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menut2" v-model="time2" full-width :use-seconds="true" @click:second="$refs.menut2.save(time2)"></v-time-picker>
            </v-menu>
          </span>
        </v-list-item>

        <!-- 아이템 -->
        <v-divider/>
        <template v-for="(item, index) in selected_itemList">
          <v-list-item :key="index" class="mt-4">
            <span style="width:160px"><v-card-title class="font-weight-bold">아이템 {{ index + 1 }}</v-card-title></span>
            <span style="width:140px">
              <v-select
                v-model="selected_itemList[index]"
                :items="itemInfoList"
                item-text="name"
                item-value="key"
                label="타입설정"
                @change="Refresh_ItemInfo"
                outlined
                hide-details
              ></v-select>
            </span>
            <span style="width:20px"/>
            <!-- 친구(1000002): 우편설정에서 등록한 AI친구 선택 (이름+썸네일) -->
            <span v-if="IsFriendItem(selected_itemList[index])" style="width:200px">
              <v-select
                v-model="selected_itemList_detail[index]"
                :items="friendDetailOptions"
                item-text="name"
                item-value="key"
                label="상세 타입"
                outlined
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <v-avatar v-if="item.thumb" tile size="22" class="mr-2"><img :src="thumbUrl(item.thumb)"/></v-avatar>
                  <span>{{ item.name }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar v-if="item.thumb" tile size="28" class="mr-2"><img :src="thumbUrl(item.thumb)"/></v-avatar>
                  <span>{{ item.name }}</span>
                </template>
              </v-select>
            </span>
            <span v-if="IsFriendItem(selected_itemList[index])" style="width:20px"/>
            <span style="width:120px">
              <v-text-field :label="IsFriendItem(selected_itemList[index]) ? '지급보너스 (%)' : '지급 수량'" v-model="selected_itemList_count[index]" type="number"></v-text-field>
            </span>
            <template v-if="IsFriendItem(selected_itemList[index])">
              <span style="width:10px"/>
              <span style="width:120px">
                <v-text-field label="유지시간 (Sec)" v-model="selected_itemList_duration[index]" type="number"></v-text-field>
              </span>
              <span style="width:10px"/>
              <v-btn width="70px" class="mr-2" style="background-color: #b9fbc0; color: black;" @click="Select_ItemSetTime(index, 604800)">1주</v-btn>
              <v-btn width="70px" class="mr-2" style="background-color: #6be585; color: black;" @click="Select_ItemSetTime(index, 1209600)">2주</v-btn>
              <v-btn width="70px" style="background-color: #2ecc71; color: black;" @click="Select_ItemSetTime(index, 2592000)">한달</v-btn>
            </template>
            <span style="width:20px"/>
            <span v-if="(selected_itemList.length - 1) !== index">
              <v-btn elevation="2" icon outlined @click="OnRemoveItem(index)">
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </span>
            <v-spacer/>
          </v-list-item>
        </template>

        <v-divider class="mt-4"/>
        <v-list-item class="mt-4">
          <v-spacer></v-spacer>
          <v-btn width="120px" color="lime accent-3" @click="OnRegist_Mail" :loading="loadingData">등록하기</v-btn>
          <v-spacer></v-spacer>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- ===== 발송 이력 1건 수정 다이얼로그 ===== -->
    <v-dialog v-model="mailDetailDialog" max-width="640" persistent scrollable>
      <v-card>
        <v-toolbar dark color="#37474F" flat>
          <v-toolbar-title>발송이력 수정 · #{{ editMail.mail_no }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="mailDetailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text style="max-height:70vh;">
          <v-row class="mt-1" dense>
            <v-col cols="6"><v-text-field label="고유번호" :value="editMail.mail_no" readonly dense hide-details></v-text-field></v-col>
            <v-col cols="6"><v-text-field label="타입" :value="editMail.type" readonly dense hide-details></v-text-field></v-col>
            <v-col cols="6"><v-text-field label="타겟(USER_ID)" :value="editMail.target" readonly dense hide-details></v-text-field></v-col>
            <v-col cols="6"><v-text-field label="등록일자" :value="editMail.create_dt" readonly dense hide-details></v-text-field></v-col>
          </v-row>

          <v-text-field class="mt-4" label="메일 제목" v-model="editMail.title" hide-details="auto"></v-text-field>
          <v-textarea class="mt-3" label="문구" v-model="editMail.message" auto-grow rows="3" hide-details="auto"></v-textarea>

          <div class="text-subtitle-2 font-weight-bold mt-4 mb-1">수령 시작일시</div>
          <div class="d-flex" style="gap:12px;">
            <v-menu v-model="mailStartMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="editMail.start_date" label="시작 날짜" readonly v-bind="attrs" v-on="on" hide-details style="max-width:160px;"></v-text-field>
              </template>
              <v-date-picker v-model="editMail.start_date" @change="mailStartMenu = false"></v-date-picker>
            </v-menu>
            <v-text-field v-model="editMail.start_time" label="시작 시간 (HH:mm:ss)" hide-details style="max-width:160px;"></v-text-field>
          </div>

          <div class="text-subtitle-2 font-weight-bold mt-4 mb-1">수령 종료일시</div>
          <div class="d-flex" style="gap:12px;">
            <v-menu v-model="mailEndMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="editMail.end_date" label="종료 날짜" readonly v-bind="attrs" v-on="on" hide-details style="max-width:160px;"></v-text-field>
              </template>
              <v-date-picker v-model="editMail.end_date" @change="mailEndMenu = false"></v-date-picker>
            </v-menu>
            <v-text-field v-model="editMail.end_time" label="종료 시간 (HH:mm:ss)" hide-details style="max-width:160px;"></v-text-field>
          </div>

          <v-textarea class="mt-4 mail-item-json" label="등록한 아이템 (JSON)" v-model="editMail.itemJson" auto-grow rows="6" hint="등록한 아이템(JSON 배열). 형식 유지 권장" persistent-hint></v-textarea>

          <div class="grey--text text-caption mt-4">이미 읽거나 수령한 유저에게는 소급 적용되지 않습니다.</div>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="mailDetailDialog = false">취소</v-btn>
          <v-btn color="lime accent-3" @click="saveMailDetail">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 발송 이력 -->
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>메일 발송 이력</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="LoadRecentMailInfo"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>
      <v-list>
        <v-data-table
          :footer-props="{'items-per-page-options': [20, 50, -1]}"
          :headers="headers"
          :items="mail_history_all"
          :loading="loadingData"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.MAIL_NO }}</td>
              <td>{{ row.item.MAIL_INFO && row.item.MAIL_INFO.title }}</td>
              <td>{{ row.item._USER_ID }}</td>
              <td>{{ row.item.CREATE_DT }}</td>
              <td>{{ row.item.EXPIRE_START_DT + ' ~ ' + row.item.EXPIRE_END_DT }}</td>
              <td>{{ row.item.USER_ID }}</td>
              <td><v-btn icon small color="primary" @click="openMailDetail(row.item)"><v-icon small>mdi-pencil</v-icon></v-btn></td>
            </tr>
          </template>
        </v-data-table>
      </v-list>
    </v-card>
    <div class="py-12"/>
  </div>
</template>

<script>
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import { pnt_factory_mail } from '../../api/pnt_factory';
import config from '../../config/config';
const { FileUpload_Async, FileUpload_JSON } = require('../../util/fileutil');

// 친구(1000002) 기본 상세 타입 — 게임서버 pnt_factory/mail_read.js ai_friend_info 와 동일 키
const FRIEND_BASE_DETAIL_KEYS = [{ name: '(GM)AI친구', key: '2000000' }];

export default {
  name: 'PntFactoryGameMail',
  data: () => ({
    loadingData: false,
    isMailAll: false,
    targetUser: '',
    mailTitle: '이벤트보상',
    mailMessage: '이벤트 보상이 지급 되었습니다.',
    date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    date_end: '',
    time1: '00:00:00',
    time2: '23:59:59',
    date_picker_1: false,
    date_picker_2: false,
    menut1: false,
    menut2: false,
    itemInfoList: [
      { name: '보석', key: '1000001' },
      { name: '친구', key: '1000002' },
      { name: '노멀티켓', key: '1000003' },
      { name: '프리미엄티켓', key: '1000004' },
    ],
    selected_itemList: [],
    selected_itemList_count: [],
    selected_itemList_detail: [],    // 친구(1000002) 상세 타입 (AI친구 id)
    selected_itemList_duration: [],  // 친구(1000002) 유지시간(초)

    // === 우편설정(AI친구 config) — S3 pnt_factory/manage/{dev|live}/mail_config.json ===
    mailConfigDialog: false,
    mailFriends: [],        // [{ id, name, thumb }]
    newFriendName: '',
    newFriendFile: null,
    newFriendPreview: '',
    friendSaving: false,
    mail_history_all: [],
    headers: [
      { text: '고유번호', value: 'mail_no' },
      { text: '메일 제목', value: 'title' },
      { text: '관리자', value: 'admin' },
      { text: '등록일자', value: 'regist_date' },
      { text: '수령기간', value: 'get_date' },
      { text: '타겟', value: 'target' },
      { text: '상세', value: 'detail', sortable: false },
    ],

    // === 발송 이력 수정 다이얼로그 ===
    mailDetailDialog: false,
    mailStartMenu: false,
    mailEndMenu: false,
    editMail: { mail_no: null, type: '', target: '', create_dt: '', title: '', message: '', start_date: '', start_time: '00:00:00', end_date: '', end_time: '23:59:59', itemJson: '[]', _orig: {} },
  }),
  computed: {
    // 친구 상세 타입 = 기본(GM) + 우편설정에서 등록한 AI친구
    friendDetailOptions() {
      return FRIEND_BASE_DETAIL_KEYS.concat(this.mailFriends.map(f => ({ key: f.id, name: f.name, thumb: f.thumb })));
    },
    mailTypeText() {
      return this.isMailAll ? '[전체메일 발송] - 신중하게 작성 요망.' : '[타겟유저 발송] - 유저의 아이디가 필수입니다.';
    },
  },
  created() {
    this.date_end = moment().add(1, 'M').format('YYYY-MM-DD');
    this.LoadRecentMailInfo();
    this.LoadMailConfig();
    this.Refresh_ItemInfo();
    const q = this.$route && this.$route.query;
    if (q && q.USER_ID) {
      this.targetUser = q.USER_ID;
    }
  },
  methods: {
    async LoadRecentMailInfo() {
      try {
        const body = await pnt_factory_mail.get_mail_list_recent();
        this.mail_history_all = body?.recent_mail_list || body?.mail_list || [];
      } catch (e) {
        console.error('[PntFactory Mail] get_mail_list_recent', e);
      }
    },
    Refresh_ItemInfo() {
      const tempItems = [];
      const tempCounts = [];
      const tempDetails = [];
      const tempDurations = [];
      for (let i = 0; i < this.selected_itemList.length; i++) {
        if (this.selected_itemList[i] != null) {
          tempItems.push(this.selected_itemList[i]);
          tempCounts.push(this.selected_itemList_count[i] ?? 0);
          tempDetails.push(this.selected_itemList_detail[i]);
          tempDurations.push(this.selected_itemList_duration[i]);
        }
      }
      this.selected_itemList = [];
      this.selected_itemList_count = [];
      this.selected_itemList_detail = [];
      this.selected_itemList_duration = [];
      for (let i = 0; i < tempItems.length; i++) {
        this.selected_itemList.push(tempItems[i]);
        this.selected_itemList_count.push(tempCounts[i]);
        this.selected_itemList_detail.push(tempDetails[i]);
        this.selected_itemList_duration.push(tempDurations[i]);
      }
      this.selected_itemList.length = tempItems.length + 1;
      this.selected_itemList_count.length = tempItems.length + 1;
      this.selected_itemList_detail.length = tempItems.length + 1;
      this.selected_itemList_duration.length = tempItems.length + 1;
    },
    IsFriendItem(key) {
      return String(key) === '1000002';
    },
    Select_ItemSetTime(index, sec) {
      this.$set(this.selected_itemList_duration, index, sec);
    },
    OnRemoveItem(index) {
      this.selected_itemList[index] = undefined;
      this.Refresh_ItemInfo();
    },
    Make_ItemResultInfo() {
      const result = [];
      for (let i = 0; i < this.selected_itemList.length; i++) {
        if (this.selected_itemList[i] !== undefined) {
          const itemInfo = {
            key: this.selected_itemList[i],
            count: this.selected_itemList_count[i] || 0,
          };
          if (this.IsFriendItem(this.selected_itemList[i])) {
            // 유지시간 미입력 시 게임서버 기본값(3600초) 사용
            if (this.selected_itemList_duration[i]) itemInfo.duration = Number(this.selected_itemList_duration[i]);
            const detailKey = this.selected_itemList_detail[i];
            if (detailKey != undefined) {
              itemInfo.detail_key = detailKey;
              // 우편설정에서 등록한 AI친구를 골랐다면 이름/썸네일도 함께 저장 (게임서버가 우선 사용)
              const friend = this.mailFriends.find(f => f.id === detailKey);
              if (friend) {
                itemInfo.name = friend.name;
                // 전체 URL 이 아니라 S3 상대경로(pnt_factory/...png)만 저장
                let thumbPath = (friend.thumb || '').replace(config.s3_ImgQuizBucket, '');
                if (thumbPath.charAt(0) === '/') thumbPath = thumbPath.slice(1);
                itemInfo.thumb = thumbPath;
              }
            }
          }
          result.push(itemInfo);
        }
      }
      return result;
    },
    async OnRegist_Mail() {
      if (!this.isMailAll && !this.targetUser) {
        alert('타겟 유저발송은 유저아이디를 입력해야합니다.');
        return;
      }
      const reward_item = this.Make_ItemResultInfo();
      if (reward_item.length === 0) {
        if (!confirm('아이템이 지정되지 않았습니다. 그래도 보내시겠습니까?')) return;
      }
      const expire_start = this.date_begin + ' ' + this.time1;
      const expire_end = this.date_end + ' ' + this.time2;
      const mail_type = this.isMailAll ? 'all' : 'single';
      const user_id = this.isMailAll ? 'ALL' : this.targetUser;
      const mail_info = {
        item: reward_item,
        title: this.mailTitle,
        message: this.mailMessage,
      };
      const admin_user = this.$store.state.user_id || '';
      this.loadingData = true;
      try {
        await pnt_factory_mail.create_mail({ mail_type, user_id, mail_info, expire_start, expire_end, admin_user });
        alert('완료!');
        await this.LoadRecentMailInfo();
      } catch (e) {
        console.error('[PntFactory Mail] create_mail', e);
        alert('메일 발송 실패');
      } finally {
        this.loadingData = false;
      }
    },
    // 발송 이력 1건의 상세보기 다이얼로그를 연다.
    openMailDetail(item) {
      let info = item.MAIL_INFO;
      if (typeof info === 'string') {
        try { info = JSON.parse(info); } catch (e) { info = {}; }
      }
      if (info == null || typeof info !== 'object') info = {};

      const fmt = (v) => {
        if (!v) return '';
        if (typeof v === 'string' && !v.includes('T')) return v;
        return moment(v).format('YYYY-MM-DD HH:mm:ss');
      };
      const startParts = fmt(item.EXPIRE_START_DT).split(' ');
      const endParts = fmt(item.EXPIRE_END_DT).split(' ');

      this.editMail = {
        mail_no: item.MAIL_NO,
        type: item.TYPE || '',
        target: item.USER_ID || '',
        create_dt: item.CREATE_DT || '',
        title: info.title || '',
        message: info.message || '',
        start_date: startParts[0] || '',
        start_time: startParts[1] || '00:00:00',
        end_date: endParts[0] || '',
        end_time: endParts[1] || '23:59:59',
        itemJson: JSON.stringify(info.item ?? [], null, 2),
        _orig: info,
      };
      this.mailDetailDialog = true;
    },
    // 수정 내용을 저장한다. (발송 이력 1건 = 실제 유저 우편 1건)
    async saveMailDetail() {
      let parsedItems;
      try {
        parsedItems = JSON.parse(this.editMail.itemJson);
      } catch (e) {
        alert('아이템 JSON 형식이 올바르지 않습니다: ' + e.message);
        return;
      }
      const start_date = (this.editMail.start_date || '').trim();
      const start_time = (this.editMail.start_time || '').trim();
      const end_date = (this.editMail.end_date || '').trim();
      const end_time = (this.editMail.end_time || '').trim();
      if (!start_date || !start_time || !end_date || !end_time) {
        alert('수령 시작/종료 일시를 모두 입력하세요.');
        return;
      }
      const expire_start = start_date + ' ' + start_time;
      const expire_end = end_date + ' ' + end_time;
      const mail_info = Object.assign({}, this.editMail._orig, {
        title: this.editMail.title,
        message: this.editMail.message,
        item: parsedItems,
      });
      const mail_no = this.editMail.mail_no;
      if (!confirm('수정 내용을 저장할까요? 이미 읽거나 수령한 유저에게는 반영되지 않습니다.')) return;
      try {
        await pnt_factory_mail.edit_mail({ mail_no, mail_info, expire_start, expire_end, admin_user: this.$store.state.user_id });
        await this.LoadRecentMailInfo();
        this.mailDetailDialog = false;
        alert('수정 완료');
      } catch (e) {
        console.error('[PntFactory Mail] edit_mail', e);
        alert('수정 실패: ' + (e && e.message ? e.message : e));
      }
    },
    // ===== 우편설정(AI친구 config) — 포인트 채굴기 우편과 동일 =====
    // ServerState.json 과 같은 폴더의 mail_config.json 을 사용한다.
    mailConfigUrl() {
      // 캐시 회피용 쿼리스트링(브라우저/CDN 캐시로 옛 값이 보이는 것 방지)
      return config.serverState_URL_PNT_FACTORY.replace('ServerState.json', 'mail_config.json') + '?t=' + Date.now();
    },
    mailConfigUploadKey() {
      // S3 저장 key = 표시URL 에서 버킷 base 를 제거한 경로
      return config.serverState_URL_PNT_FACTORY.replace('ServerState.json', 'mail_config.json').replace(config.s3_ImgQuizBucket, '');
    },
    thumbUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//.test(path)) return path;   // 이미 전체 URL 이면 그대로
      return config.s3_ImgQuizBucket + path;
    },
    openMailConfig() {
      this.newFriendName = '';
      this.newFriendFile = null;
      this.newFriendPreview = '';
      this.mailConfigDialog = true;
    },
    LoadMailConfig() {
      fetch(this.mailConfigUrl())
        .then(response => {
          if (!response.ok) throw new Error('mail_config.json 없음 (' + response.status + ')');
          return response.json();
        })
        .then(data => {
          this.mailFriends = (data && Array.isArray(data.friends)) ? data.friends : [];
        })
        .catch(error => {
          // 최초에는 파일이 없을 수 있음 → 빈 목록으로 시작
          this.mailFriends = [];
          console.log('[PntFactory Mail] LoadMailConfig(빈 목록으로 시작):', error.message);
        });
    },
    SaveMailConfig() {
      // 현재 mailFriends 를 mail_config.json 으로 S3 업로드
      return FileUpload_JSON({ friends: this.mailFriends }, this.mailConfigUploadKey());
    },
    // 원본 이미지를 256x256 정사각형으로 center-crop(cover) 재단
    resizeImageTo256(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(url);
          const size = 256;
          const canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          // cover: 짧은 쪽을 채우고 넘치는 부분은 잘라냄
          const scale = Math.max(size / img.width, size / img.height);
          const w = img.width * scale;
          const h = img.height * scale;
          ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
          canvas.toBlob((blob) => {
            if (!blob) { reject(new Error('이미지 재단(toBlob) 실패')); return; }
            const outFile = new File([blob], 'thumb.png', { type: 'image/png' });
            resolve({ file: outFile, dataUrl: canvas.toDataURL('image/png') });
          }, 'image/png');
        };
        img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('이미지 로드 실패')); };
        img.src = url;
      });
    },
    onFriendThumbChange(file) {
      this.newFriendFile = null;
      this.newFriendPreview = '';
      if (!file) return;
      this.resizeImageTo256(file)
        .then(({ file: resized, dataUrl }) => {
          this.newFriendFile = resized;
          this.newFriendPreview = dataUrl;
        })
        .catch(err => {
          console.error(err);
          alert('이미지 처리에 실패했습니다: ' + err.message);
        });
    },
    async AddMailFriend() {
      const name = (this.newFriendName || '').trim();
      if (name === '') { alert('친구 이름을 입력하세요.'); return; }
      if (!this.newFriendFile) { alert('썸네일 이미지를 선택하세요.'); return; }
      this.friendSaving = true;
      try {
        // 1) 썸네일 S3 업로드 (pnt_factory/mail/thumbnail/friend_{ts}.png)
        const key = 'pnt_factory/mail/thumbnail/friend_' + Date.now() + '.png';
        const ok = await FileUpload_Async(this.newFriendFile, key);
        if (!ok) { alert('썸네일 업로드에 실패했습니다.'); return; }
        // 2) 목록에 추가 (추가만 가능)
        const friend = { id: 'F' + Date.now(), name: name, thumb: key };
        this.mailFriends.push(friend);
        // 3) mail_config.json 저장
        const saved = await this.SaveMailConfig();
        if (!saved) {
          this.mailFriends.pop(); // 저장 실패 시 롤백
          alert('mail_config.json 저장에 실패했습니다.');
          return;
        }
        // 4) 폼 초기화
        this.newFriendName = '';
        this.newFriendFile = null;
        this.newFriendPreview = '';
        alert('친구가 추가되었습니다.');
      } catch (e) {
        console.error(e);
        alert('친구 추가 중 오류: ' + e.message);
      } finally {
        this.friendSaving = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
.cms-toolbar--alert { background-color: #b71c1c !important; }
.mail-item-json >>> textarea {
  font-family: monospace;
  font-size: 13px;
}
@media (max-width: 600px) {
  .v-list-item { flex-wrap: wrap; }
  .v-list-item > span { width: 100% !important; }
  .v-data-table { overflow-x: auto; }
}
</style>
